<template>
   <Header />
   <section class="radio" v-if="isLive">
      <div class="container">
         <div v-if="showRadio && radioProgram.status == 1" class="radio__track">
            <div class="radio__track_prev" v-if="playList[indexlive].radio"
               @click="GoLive(playList[indexlive].radio, CorTime(playList[indexlive].time_to_start))">
               <div class="radio__track_play" v-if="Object.keys(radioInfo || {}).length == 0">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path
                        d="M4.36077 1.27343C3.36667 0.57687 2 1.28802 2 2.50188V9.49827C2 10.7121 3.36668 11.4233 4.36078 10.7267L9.36486 7.22028C10.2115 6.62704 10.2115 5.373 9.36484 4.77977L4.36077 1.27343Z"
                        fill="#fff" />
                  </svg>
               </div>
               <img v-if="playList[indexlive].radio.get_preview" :src="playlistDraft[indexLive].radio.get_preview"
                  @click="GoLive(playList[indexlive].radio, CorTime(playList[indexlive].time_to_start))">
               <img v-else src="@/assets/img/Cover_radio.jpg"
                  @click="GoLive(playList[indexlive].radio, CorTime(playList[indexlive].time_to_start))">
            </div>
            <div class="radio__track_block">
               <div class="radio__track_row">
<!--                   <p v-if="!inEfir" class="radio__track_active">{{ CorTime(playList[indexlive].time_to_start) }}</p>
                  <p v-else class="radio__track_active">В ЭФИРЕ</p> -->
                  <p class="radio__track_active">
                     <i18n-t keypath="radioprogram.live.status.online.singular" scope="global"></i18n-t>
                  </p>
                  <div class="radio__track_road">
                     <div class="radio__track_sound">
                        <img src="@/assets/img/radio_sound.svg" alt="">
                     </div>
                  </div>
                  <p class="radio__track_yers">0+</p>
               </div>
               <h1 v-if="playlistDraft[indexLive].radio.name">{{ playlistDraft[indexLive].radio.name }}</h1>
<!--                <h1 v-if="!inEfir">Эфир начнется в {{ CorTime(playList[indexlive].time_to_start) }}</h1>
               <h1 v-else>{{ playList[indexlive].radio.name }}</h1> -->
               <div class="radio__air">
                  <div class="radio__air_title">
                     <i18n-t tag="p" keypath="radioprogram.live.today.singular" scope="global"></i18n-t>
                     <router-link to="/radio/program">
                        <i18n-t tag="span" keypath="radioprogram.live.entire.singular" scope="global"></i18n-t>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M12.6668 6.5L8.00016 11.1667L3.3335 6.5" stroke="#019040" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                     </router-link>
                  </div>
                  <div class="radio__air_scroll">

                     <swiper 
                        slides-per-view="auto" 
                        :modules="modules" 
                        :initial-slide="indexLive"
                        :navigation="{
                           prevEl: prev,
                           nextEl: next,
                        }"
                        @swiper="onSwiper"
                     >

                        <div ref="prev" class="radio__air_scroll_btn radio__air_scroll_prev">prev</div>
                        <div ref="next" class="radio__air_scroll_btn radio__air_scroll_next">next</div>
                        <swiper-slide class="radio__air_item" v-for="list in playlistDraft">
                           <img v-if="list.radio.get_preview" :src="list.radio.get_preview" alt="">
                           <img v-else src="@/assets/img/Cover_radio.jpg" alt="">
                           <div>
                              <p class="radio__air_track">{{ list.radio.name }}</p>
                              <p class="radio__air_name" v-if="list.radio.author">{{ list.radio.author.name }}</p>
                           </div>
                        </swiper-slide>
                     </swiper>
                  </div>
                  <!-- <div class="radio__air_scroll">
                     <div class="radio__air_item" v-for="list in playList">
                        <img v-if="list.radio.get_preview" :src="list.radio.get_preview" alt="">
                        <img v-else src="@/assets/img/Cover_radio.jpg" alt="">
                        <div>
                           <p class="radio__air_track">{{ list.radio.name }}</p>
                           <p class="radio__air_name" v-if="list.radio.author">{{ list.radio.author.name }}</p>
                        </div>
                     </div>
                  </div> -->
               </div>
            </div>
         </div>
         <div class="radio__air radio__air_mob" v-if="showRadio">
            <div class="radio__air_title">
               <i18n-t tag="p" keypath="radioprogram.live.today.singular" scope="global"></i18n-t>
               <router-link to="/radio/program">
                  <i18n-t tag="span" keypath="radioprogram.live.entire.singular" scope="global"></i18n-t>
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M12.6668 6.5L8.00016 11.1667L3.3335 6.5" stroke="#019040" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
               </router-link>
            </div>
            <!-- <div class="radio__air_scroll">
               <div class="radio__air_item" v-for="list in playList">
                  <img v-if="list.radio.get_preview" :src="list.radio.get_preview" alt="">
                  <img v-else src="@/assets/img/Cover_radio.jpg" alt="">
                  <div>
                     <p class="radio__air_track">{{ list.radio.name }}</p>
                     <p class="radio__air_name" v-if="list.radio.author">{{ list.radio.author.name }}</p>
                  </div>
               </div>
            </div> -->
            <div class="radio__air_scroll">

               <swiper slides-per-view="auto" :initial-slide="indexLive" :modules="mobileModules" @swiper="onMobileSwiper">

                  <swiper-slide class="radio__air_item" v-for="list in playList">
                     <img v-if="list.radio.get_preview" :src="list.radio.get_preview" alt="">
                     <img v-else src="@/assets/img/Cover_radio.jpg" alt="">
                     <div>
                        <p class="radio__air_track">{{ list.radio.name }}</p>
                        <p class="radio__air_name" v-if="list.radio.author">{{ list.radio.author.name }}</p>
                     </div>
                  </swiper-slide>
               </swiper>
            </div>
         </div>
         <LiveChat 
            className="radio"
            :id="radioId"
            idKey="radioprogram_id"
            chatType="radio"
         />
      </div>
   </section>
   <section class="radio-slider" v-if="slideShow.length > 0">
      <CarouselSwiper :slideShow="slideShow" />
   </section>

   <PopularList />

   <CatalogRadios :radiosArray="radiosListing" />
   <section class="donate">

   </section>
   <!-- <radio-efir v-if="radioProgram.status == 1 && isLive" :radio="radioInfo"
      :autoPlay="true" :inEfir="true" :cur_time="curr_time" @clear="radioInfo = $event" :options="options"></radio-efir> -->
</template>
<!-- file="https://barsel.media:8088/m3u/stream.m3u8" -->
<style type="text/css">
.radio__air_item {
   max-width: fit-content;
}

.radio__air_scroll {
   position: relative;
}

.radio__air_scroll_btn {
   font-size: 0;
   width: 36px;
   height: 36px;
   background: rgba(255, 255, 255, 0.08);
   border: 1px solid rgba(255, 255, 255, 0.17);
   backdrop-filter: blur(42px);
   -webkit-backdrop-filter: blur(42px);
   border-radius: 12px;
   z-index: 1;
   display: flex;
   justify-content: center;
   align-items: center;
   transition: all 0.3s;
   position: absolute;
   top: 50%;
   transform: translateY(-50%);
   cursor: pointer;
}

.radio__air_scroll_btn::before {
   content: "";
   display: block;
   width: 24px;
   height: 24px;
   background: url(@/assets/img/slider_next.svg) center no-repeat;
   background-size: contain;
}

.radio__air_scroll_prev::before {
   transform: rotate(180deg);
}

.radio__air_scroll_prev {
   left: 0;
}

.radio__air_scroll_next {
   right: 0;
}
</style>

<script>
import axios from 'axios'
import moment from 'moment';
import Header from '@/components/Header/Header'
import CatalogRadios from '@/components/Swiper/Radios/CatalogRadios'
import CarouselSwiper from '@/components/Swiper/Radios/Main/CarouselSwiper'
import PopularList from '@/components/Radio/RadioBlocks/PopularList'
import RadioEfir from '@/components/Radio/RadioEfir.vue'
import LiveChat from '@/components/Chat/LiveChat'

import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Navigation, FreeMode, Mousewheel } from "swiper";

SwiperCore.use(FreeMode);

import 'swiper/css';
import 'swiper/css/navigation';
export default {
   name: 'Radio',
   data() {
      return {
         radiosListing: [],
         radioProgram: [],
         playList: [],

         slideShow: [],
         radioId: 0,
         messages: [],
         nickname: "",
         nicknameObj: "",

         message: "",

         inEfir: false,
         showRadio: false,
         indexMax: 0,
         indexlive: 0,

         startVideo: 0,

         radioInfo: {},

         componentKey: true,

         curr_time: 0,

         durationInEfir: 0,
         newRadioRedirect: false,

         inLine: 0,

         options: {
            autoplay: false,
            liveui: true,
            preload: "metdata",
            sources: [
               {
                  src:
                     `${process.env.VUE_APP_SITE_URL}:8088/m3u/stream.m3u8`,
                  type: 'application/x-mpegURL'
               }
            ],
            language: "ru",
            controlBar: {
               fullscreenToggle: false,
            },
            fluid: false,
         },

         swiper: null,
         mobileSwiper: null,

         isLive: false,
      }
   },
   mounted() {
      this.nickname = this.$store.state.nickname

      // this.TimeLive()

      // this.inLine = setInterval(() => {
      //    this.TimeLive()
      // }, 2000)
   },
   methods: {
      goTo(redirect) {
         this.$router.push(redirect)
      },
      async GetListing() {
         await axios
            .get(`api/v1/get/listing/radios/`)
            .then(response => {
               this.radiosListing = response.data
            })
            .catch(error => {
               console.log(error)
            })
      },
      onSwiper(instance) {
         this.swiper = instance;
      },
      onMobileSwiper(instance) {
         this.mobileSwiper = instance;
      },
      async GetSlideShow() {
         await axios
            .get(`api/v1/get/slideshow/radios/True/`)
            .then(response => {
               this.slideShow = response.data
            })
            .catch(error => {
               console.log(error)
            })
      },
      async GetRadioprogramToday() {
         await axios
            .get(`/api/v1/get/radioprogram/today/`)
            .then(response => {
               if (String(response.data) == 'none' || (response.data.status != 1 && response.data.status != 4)) clearInterval(this.inLine)
               else {
                  this.radioProgram = response.data
                  this.radioId = response.data.id
                  this.indexlive = response.data.index
                  // this.AllMessage()
                  this.GetPlayList(response.data.id)
                  this.loadProgramm(response.data.id)
               }


            })
            .catch(error => {
               console.log(error)
            })
      },
      async GetPlayList(value) {
         await axios
            .get(`/api/v1/get/radioprogram/radios/withads/${value}/`)
            .then(response => {
               this.playList = response.data
               this.indexMax = response.data.length

               if (this.indexMax < this.indexlive || this.indexMax == this.indexlive) {
                  this.showRadio = false
                  localStorage.removeItem("radio")
                  this.$store.commit('removeRadio')
                  this.$store.commit('initializeStore')
               } else {
                  this.RadioNow()
                  this.showRadio = true
                  this.GoLive(this.playList[this.indexlive].radio, this.CorTime(this.playList[this.indexlive].time_to_start))
                  this.durationInEfir = parseInt(Number(this.playList[this.indexlive].radio.duration) + 15)
               }
            })
            .catch(error => {
               console.log(error)
            })
      },
      RadioNow() {
         if (this.indexMax > this.indexlive || this.indexMax != this.indexlive) {
            this.startVideo = moment(this.playList[this.indexlive].time_to_start, "HH:mm:ss").format("HH:mm:ss")
         }
      },
      async GetNextRadio() {
         await axios
            .patch(`/api/v1/get/radioprogram/next/radio/${this.radioId}/${this.indexlive + 1}/`)
            .then(response => {
               localStorage.removeItem("radio")
               this.$store.commit('removeRadio')
               this.$store.commit('initializeStore')

               // this.radioInfo = {}

               // this.forceRerender()

               setTimeout(() => {
                  if (this.indexMax < this.indexlive || this.indexMax == this.indexlive) {
                     this.showRadio = false
                  } else {
                     this.GetRadioprogramToday()
                     // this.newRadioRedirect = true
                  }
               }, 500)

            })
            .catch(error => {
               console.log(error)
            })
      },
      async PublishRadio() {
         await axios
            .patch(`/api/v1/radio/update/status/${this.radioInfo.id}/${0}/`)
            .then(response => {

            })
            .catch(error => {
               console.log(error)
            })
      },
      async SendMessage() {
         const BigData = {
            radioprogram_id: this.radioId,
            name: this.nickname,
            message: this.message,
         }

         await axios
            .post(`/api/v1/chat/radio/${this.radioId}/`, BigData)
            .then(response => {
               this.message = ""
               // this.AllMessage()
            })
            .catch(error => {
               console.log(error)
            })

      },
      async AllMessage() {
         await axios
            .get(`/api/v1/chat/radio/${this.radioId}/`)
            .then(response => {
               this.messages = response.data
            })
            .catch(error => {
               console.log(error)
            })

      },
      async forceRerender() {
         this.componentKey = false;

         await this.$nextTick();

         this.componentKey = true;
      },
      saveName(nick) {
         this.$store.commit('setNickname', nick)
         localStorage.setItem("nickname", nick)
         this.$store.commit('initializeStore')

         this.nickname = nick
      },
      CorTime(timeValue) {
         moment.locale('ru');
         const time = moment(timeValue, "HH:mm:ss").format("HH:mm")
         return time
      },
      async TimeLive() {
         await axios
            .get(`/api/v1/get/time-live/`)
            .then(response => {
               this.timelive = moment(response.data.Time, "HH:mm:ss").format("HH:mm:ss")

               this.curr_time = moment.duration(this.timelive).asSeconds() - moment.duration(this.startVideo).asSeconds()

               if (this.durationInEfir != 0 && this.radioProgram.status == 1) {
                  if (this.curr_time >= this.durationInEfir) {
                     // window.location.reload()
                     this.PublishRadio()
                     this.GetNextRadio()
                  }
               }
            })
            .catch(error => {
               console.log(error)
            })
      },
      GoLive(value, time) {
         // if (time <= this.timelive) {
            this.inEfir = true
            this.radioInfo = value
         // }
      },
      async loadProgramm(value) {
         await axios.get(`/api/v1/check/radioprogram/show/${value}/`)
            .then(res => {
               this.isLive = res.data.show
            })
      },
   },
   components: {
      Header,
      CatalogRadios,
      CarouselSwiper,
      PopularList,
      'radio-efir': RadioEfir,
      Swiper,
      SwiperSlide,
      LiveChat
   },
   // created() {
   //    this.GetSlideShow()
   //    this.GetListing()
   //    this.GetRadioprogramToday()
   // },
   computed: {
      indexLive() {
         const time = moment.duration(this.timelive).asSeconds();

         const index = this.playlistDraft.findIndex((item) => time <= moment.duration(item.time_to_start).asSeconds()) - 1;

         const indexLast = this.playlistDraft.length - 1;

         if (index === -2) {
            return indexLast;
         }

         return Math.max(0, index);
      },
      playlistDraft() {
         return this.playList.filter((item) => item.radio.draft !== 2);
      }
   },
   watch: {
      radioInfo(value) {
         this.radioInfo = value
         if (Object.keys(value).length) {
            this.$store.state.radio = {}
         }
      },
      indexLive(newValue, oldValue) {
         if (newValue === oldValue) return;

         this.indexlive !== newValue && (this.indexlive = newValue);
         
         if (!this.swiper) return;
         
         this.swiper.slideTo(newValue);

         if (!this.mobileSwiper) return;

         this.mobileSwiper.slideTo(newValue);
      }
   },
   setup() {
      const prev = ref(null);
      const next = ref(null);
      return {
         modules: [Navigation],
         mobileModules: [Mousewheel],
         prev,
         next,
      };
   },
}
</script>
